__webpack_require__.p = "https://lijc.rightinthebox.com/promotion_src/public/optimus-mini/_next/";